var React = require('react');

function SignPost (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.34 14.13L16.16 12.38C15.85 12.14 15.46 12 15.06 12H12.75V9H17.22C18.19 9 18.97 8.22 18.97 7.25V3.75C18.97 2.78 18.19 2 17.22 2H8.95997C8.56997 2 8.17997 2.14 7.86997 2.38L5.67997 4.13C4.80997 4.83 4.80997 6.17 5.67997 6.87L7.86997 8.62C8.17997 8.86 8.56997 9 8.95997 9H11.25V12H6.79997C5.82997 12 5.04997 12.78 5.04997 13.75V17.25C5.04997 18.22 5.82997 19 6.79997 19H11.25V21.25H8.99997C8.58997 21.25 8.24997 21.59 8.24997 22C8.24997 22.41 8.58997 22.75 8.99997 22.75H15C15.41 22.75 15.75 22.41 15.75 22C15.75 21.59 15.41 21.25 15 21.25H12.75V19H15.06C15.46 19 15.85 18.86 16.16 18.62L18.34 16.87C19.22 16.17 19.22 14.83 18.34 14.13Z"}));
}

SignPost.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = SignPost;

SignPost.default = SignPost;
